import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { Extension } from "@tiptap/core";
import { Plugin } from 'prosemirror-state';

export const HighlightRangesExt = Extension.create({
  name: "HighlightRanges",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        state: {
          init: () => DecorationSet.empty,
          apply(tr, old) {
            // Keep decorations unless explicitly replaced
            return tr.getMeta("spell.highlight") || old.map(tr.mapping, tr.doc);
          },
        },
        props: {
          decorations(state) {
            return this.getState(state);
          },
        },
      }),
    ];
  },

  // @ts-ignore
  addCommands() {
      
    return {

      highlightRanges: ranges => ({editor, chain, tr}) => {
        const { view, state } = editor
        // const { from, to } = view.state.selection        
        const decos = ranges.map(([from, to]) =>
          Decoration.inline(from, to, { class: "bg-yellow-200" })
        );
        const decoSet = DecorationSet.create(editor.state.doc, decos);
      
        editor.view.dispatch(
          editor.state.tr.setMeta("spell.highlight", decoSet)
        );   
        
      },

      dropHighlights: () => ({editor, chain, tr}) => {
        const { view, state } = editor

        editor.view.dispatch(
          editor.state.tr.setMeta("spell.highlight", DecorationSet.empty)
        );  
        
      },
    }
  }
  
});


